import { render } from "./FinanceProblems.vue?vue&type=template&id=630c5f00&scoped=true&ts=true"
import script from "./FinanceProblems.vue?vue&type=script&lang=ts"
export * from "./FinanceProblems.vue?vue&type=script&lang=ts"

import "./FinanceProblems.vue?vue&type=style&index=0&id=630c5f00&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630c5f00"]])

export default __exports__